import React from 'react';
import { motion } from 'framer-motion';
import { XIcon } from 'lucide-react';
import { problems } from '../data/problems';
export function ProblemSection() {
  return <section className="bg-stage py-16 sm:py-20" aria-labelledby="problem-title" data-id="element-248" data-mp="30h7kvn5mjqti">
      <div className="mx-auto max-w-4xl px-4" data-id="element-249" data-mp="30jaml4g538e2">
        <div className="text-center" data-id="element-250" data-mp="2vq7nkgslf6qh">
          <p className="text-xs font-extrabold uppercase tracking-[.18em] text-gold" data-id="element-251" data-mp="2vp6euiz1uwbx">La realidad docente</p>
          <h2 id="problem-title" className="mx-auto mt-3 max-w-3xl text-balance text-3xl font-extrabold leading-tight text-white sm:text-4xl" data-id="element-252" data-mp="39jz0lz5j98qy">
            ¿Cuántas clases más vas a preparar sobre Gestión Cultural sin tener el material correcto?
          </h2>
          <p className="mx-auto mt-5 max-w-3xl leading-relaxed text-mutedDark" data-id="element-253" data-mp="3ei0k2l6vfa2y">
            Buscás información en internet que no tiene secuencia didáctica ni menciona Argentina. Armás planificaciones desde
            cero cada ciclo lectivo. Y cuando un alumno pregunta cómo acceder a un subsidio del FNA, qué dice la Constitución
            sobre derechos culturales, cómo se organiza un festival con presupuesto mínimo en el interior del país o qué hace
            realmente un gestor cultural en una institución pública argentina, no tenés una respuesta que los enganche con la
            realidad del campo cultural argentino.
          </p>
          <p className="mt-4 font-bold text-gold" data-id="element-254" data-mp="x6cv0j4bmn7b">No es falta de vocación docente. Es que nadie armó el sistema completo para vos.</p>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="panel-dark mt-9 rounded-2xl border border-magenta/40 p-6 sm:p-8" data-id="element-255" data-mp="171mx16upyul3">
          <p className="mb-5 font-display text-xl font-bold text-[#C9A9F0]" data-id="element-256" data-mp="3dugxrd0bdyqv">Esto te está pasando ahora mismo:</p>
          <ul className="grid gap-4 sm:grid-cols-2" data-id="element-257" data-mp="3hv96841d3zm3">
            {problems.map(item => <li key={item} className="flex gap-3 text-sm leading-relaxed text-onDark" data-id="element-258" data-mp="p122kdiyv7pt">
                <span className="mt-0.5 rounded-full bg-magenta/20 p-1" data-id="element-259" data-mp="k2ha509yhsbx">
                  <XIcon className="h-3.5 w-3.5 text-[#C9A9F0]" data-id="element-260" data-mp="y1gnhbs0qkss" />
                </span>
                {item}
              </li>)}
          </ul>
        </motion.div>

        <p className="mt-8 text-center font-bold text-gold" data-id="element-261" data-mp="17z4sqvn93ap7">
          ¿Y si esta fuera la última semana que enseñás Gestión Cultural sin tener todo resuelto?
        </p>
      </div>
    </section>;
}